import React from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import TableRowsIcon from "@mui/icons-material/TableRows";
import GroupIcon from "@mui/icons-material/Group";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import TimelineIcon from "@mui/icons-material/Timeline";
import DeviceHubIcon from "@mui/icons-material/DeviceHub";
import SettingsIcon from "@mui/icons-material/Settings";
import SummarizeIcon from "@mui/icons-material/Summarize";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import PlaylistAddCheckRoundedIcon from "@mui/icons-material/PlaylistAddCheckRounded";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ExtensionIcon from "@mui/icons-material/Extension";

const actionItems = [
  {
    id: "DASHBOARD",
    title: "Home",
    sideNavTitle: "Home",
    icon: <DashboardIcon className="dashboard" />,
    navigateTo: "/control-panel",
    bgcolor: "#F6CA9F",
    color: "#B7793D",
    download: false,
  },
  {
    id: "SETTINGS",
    title: "Settings",
    sideNavTitle: "Settings",
    icon: <SettingsIcon className="settings" />,
    navigateTo: "/settings",
    bgcolor: "#CDE4F0",
    color: "#467289",
    download: false,
    children: [
      {
        id: "GENERAL",
        title: "General",
        className: "general",
        sideNavTitle: "General",
        icon: <TimelineIcon />,
        navigateTo: "/general",
      },
      {
        id: "MANAGE_SSO",
        title: "SSO Settings",
        className: "sso_settings",
        sideNavTitle: "SSO Settings",
        icon: <TableRowsIcon />,
        navigateTo: "/auth-providers",
        bgcolor: "#CDE4F0",
        color: "#467289",
      },
      {
        id: "CONNECTIONS",
        title: "Connections",
        className: "connections",
        sideNavTitle: "Connections",
        icon: <DeviceHubIcon />,
        navigateTo: "/connections",
      },
    ],
  },
  {
    id: "USER_MANAGEMENT",
    title: "Users",
    sideNavTitle: "Users",
    icon: <GroupIcon className="users" />,
    navigateTo: "/user-management",
    bgcolor: "#CDE4F0",
    color: "#467289",
    download: false,
  },
  {
    id: "DATA_CATALOG",
    title: "Data Catalog",
    sideNavTitle: "Data Catalog",
    icon: <MapOutlinedIcon className="data_catalog" />,
    navigateTo: "/data-catalog",
    bgcolor: "#BCC7EB",
    color: "#2C4391",
    download: false,
  },
  {
    id: "MY_WORKSPACES",
    title: "Workspaces",
    sideNavTitle: "Workspaces",
    icon: <ShowChartIcon className="workspaces" />,
    navigateTo: "/my-workspaces",
    bgcolor: "#bddbaf",
    color: "#367616",
    download: false,
  },
  {
    id: "REPORTS",
    title: "Reports",
    sideNavTitle: "Reports",
    icon: <SummarizeIcon className="reports" />,
    navigateTo: "/reports",
    bgcolor: "#bddbaf",
    color: "#367616",
    download: false,
  },
  {
    id: "DATA_STEWARDSHIP",
    title: "Cases",
    sideNavTitle: "Cases",
    icon: <PlaylistAddCheckRoundedIcon sx={{ transform: "scale(1.2)" }} className="cases" />,
    navigateTo: "/cases",
    bgcolor: "#E5CCCC",
    color: "#b7793d",
    download: false,
  },
  {
    id: "SANDBOX",
    title: "Sandbox",
    sideNavTitle: "Sandbox",
    icon: <ExtensionIcon sx={{ transform: "scale(1.2)" }} className="sandbox" />,
    navigateTo: "/sandbox",
    bgcolor: "#E5CCCC",
    color: "#b7793d",
    download: false,
  },
];

const bottomActionItems = [
  {
    id: "USER_GUIDE",
    title: "Guide",
    sideNavTitle: "Guide",
    icon: <MenuBookIcon className="guide" />,
    navigateTo: "/pdfs/Guide/Vortex Guide.pdf",
    bgcolor: "#E5CCCC",
    color: "#b7793d",
    download: true,
  },
];

export const getActionItems = (idList) => {
  const items = actionItems.filter(
    (action) => !["REPORTS", "SETTINGS", "SANDBOX"].includes(action.id) && idList.includes(action.id)
  );
  const bottomItems = bottomActionItems.filter((action) => action.id !== "USER_GUIDE" && idList.includes(action.id));

  return items.concat(bottomItems);
};

export const getSidenavItems = (idList) => {
  let sidenavItems = [
    {
      ...actionItems[0],
      title: actionItems[0].sideNavTitle,
    },
  ];

  actionItems.forEach((action) => {
    if (idList.includes(action.id))
      sidenavItems.push({
        ...action,
        title: action.sideNavTitle,
      });
  });

  return sidenavItems;
};

export const getSidenavBottomItems = (idList) => {
  let sidenavItems = [];

  bottomActionItems.forEach((action) => {
    if (idList.includes(action.id))
      sidenavItems.push({
        ...action,
        title: action.sideNavTitle,
      });
  });

  return sidenavItems;
};
